import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MarketMovers = ({ onStockSelect, onAddToWatchlist }) => {
  const gainers = [
    { symbol: 'NVDA', name: 'NVIDIA Corp', price: 456.78, change: 18.45, changePercent: 4.21 },
    { symbol: 'AMD', name: 'Advanced Micro Devices', price: 112.34, change: 8.90, changePercent: 8.60 },
    { symbol: 'PLTR', name: 'Palantir Technologies', price: 23.45, change: 1.89, changePercent: 8.76 }
  ];

  const losers = [
    { symbol: 'TSLA', name: 'Tesla Inc', price: 245.60, change: -8.90, changePercent: -3.50 },
    { symbol: 'NFLX', name: 'Netflix Inc', price: 425.67, change: -12.45, changePercent: -2.84 },
    { symbol: 'PYPL', name: 'PayPal Holdings', price: 67.89, change: -3.21, changePercent: -4.52 }
  ];

  const mostActive = [
    { symbol: 'AAPL', name: 'Apple Inc', price: 189.25, change: 2.45, changePercent: 1.31, volume: '52.3M' },
    { symbol: 'TSLA', name: 'Tesla Inc', price: 245.60, change: -8.90, changePercent: -3.50, volume: '89.2M' },
    { symbol: 'AMZN', name: 'Amazon.com Inc', price: 3245.75, change: 12.80, changePercent: 0.40, volume: '34.7M' }
  ];

  const handleAddToWatchlist = (e, stock) => {
    e.stopPropagation();
    onAddToWatchlist(stock);
  };

  const renderStockList = (stocks, title, showVolume = false) => (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="font-semibold text-foreground mb-4 flex items-center">
        <Icon 
          name={title === 'Top Gainers' ? 'TrendingUp' : title === 'Top Losers' ? 'TrendingDown' : 'Activity'} 
          size={18} 
          className="mr-2" 
        />
        {title}
      </h3>
      <div className="space-y-3">
        {stocks.map((stock, index) => (
          <div
            key={stock.symbol}
            onClick={() => onStockSelect(stock)}
            className="flex items-center justify-between p-3 hover:bg-muted rounded-lg cursor-pointer transition-colors"
          >
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <span className="text-primary font-semibold text-xs">{index + 1}</span>
              </div>
              <div>
                <div className="font-semibold text-foreground">{stock.symbol}</div>
                <div className="text-sm text-muted-foreground truncate max-w-32">{stock.name}</div>
                {showVolume && (
                  <div className="text-xs text-muted-foreground">Vol: {stock.volume}</div>
                )}
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <div className="text-right">
                <div className="font-mono text-sm text-foreground">${stock.price.toFixed(2)}</div>
                <div className={`font-mono text-xs ${stock.change >= 0 ? 'text-success' : 'text-destructive'}`}>
                  {stock.change >= 0 ? '+' : ''}{stock.change.toFixed(2)} ({stock.change >= 0 ? '+' : ''}{stock.changePercent.toFixed(2)}%)
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={(e) => handleAddToWatchlist(e, stock)}
                className="h-8 w-8 hover:bg-primary/10"
              >
                <Icon name="Plus" size={14} />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-foreground">Market Movers</h2>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {renderStockList(gainers, 'Top Gainers')}
        {renderStockList(losers, 'Top Losers')}
        {renderStockList(mostActive, 'Most Active', true)}
      </div>
    </div>
  );
};

export default MarketMovers;